import { InjectionToken } from '@angular/core';
import { CountryIso3Code } from '../models/country/country-iso-3-code.enum';

export const COUNTRY_ISO_3_CODE = new InjectionToken<CountryIso3Code>(
  'Country ISO 3 code',
);
